import { Plus, Search, Upload } from "lucide-react";
import CSVImage from "@/assets/images/CSV.png";
import LockImage from "@/assets/images/Lock.png";
import EmailImage from "@/assets/images/Email.png";
import AiIcon from "@/assets/svg/Ai-Icon";

export const UploadTypes = [
  {
    id: 1,
    name: "Upload using CSV",
    typeof: "csv",
    icon: <img src={CSVImage} alt="CSV" className="w-5 h-5" />,
    buttonText: "Upload",
    ButtonIcon: <Upload size={16} />,
  },
  {
    id: 2,
    name: "Manually add contacts",
    typeof: "manual",
    icon: <img src={EmailImage} alt="Email" className="w-5 h-5" />,
    buttonText: "Add",
    ButtonIcon: <Plus size={16} />,
  },
  {
    id: 3,
    name: "Find Contacts",
    icon: <AiIcon className="w-5 h-5 object-contain" color="#207C97" />,
    buttonText: "Find",
    typeof: "relevant",
    ButtonIcon: <Search size={16} />,
  },
  {
    id: 4,
    name: "Add using CRM",
    icon: <img src={LockImage} alt="Email" className="w-5 h-5" />,
    buttonText: "Coming Soon",
    typeof: "locked",
    disabled: true,
  },
];

export const OPTION_LABELS = {
  csv: {
    title: "CSV Import",
    description: "Upload a CSV file to add contacts",
  },
  manual: {
    title: "Add Contact Manually",
    description: "Add a single contact by filling in the details",
  },
  locked: {
    title: "Add using CRM",
    description: "Connect your CRM to sync contacts",
  },
};